import { computed } from 'mobx';
import { IEntityStore, IUser, IUserExt } from '../../main/entities';
import { MgHasher } from '../../mg/MgHasher';
import { IOcResponse } from '../../services/CommSvc';
import { AbstractRepo } from './AbstractRepo';

function remapUserStat(us: Record<string, any>) {
	return {
		stat_lastOrderTimestamp: us.lastOrderTimestamp,
		stat_previousMonthOrderCount: us.previousMonthOrderCount,
		stat_currentMonthOrderCount: us.currentMonthOrderCount,
		stat_orderCount: us.orderCount,
		stat_prevalentDayOfWeek: us.prevalentDayOfWeek,
	};
}

export class AdmUserRepo extends AbstractRepo<IUserExt> implements IEntityStore<IUserExt> {
	private readonly repos: Array<IEntityStore>;

	constructor(userRepo: IEntityStore<IUser>, userStatRepo: IEntityStore<any>) {
		super('AdmUser', () => {
			const r = new Map<number, Record<string, any>>(userRepo.allAsList.map(u => [u.id, u]));
			userStatRepo.allAsList.forEach(us => r.set(us.user, {...r.get(us.user), ...remapUserStat(us)}));
			return [...r.values()] as any;
		});
		this.repos = [userRepo, userStatRepo];
	}

	@computed get etag() {
		for (const r of this.repos) {
			if (!r.etag) return '';
		}
		return new MgHasher().addUnordered(this.repos.map(r => r.etag + ' ' + r.id)).addString(this.id).toString();
	}

	fetch(mode?: 'NORMAL' | 'DIRECT' | 'INVALIDATE') {
		return Promise.all(this.repos.map(r => r.fetch(mode)));
	}

	handleResponse(responsePromise: Promise<IOcResponse>, successMessage: string) : Promise<unknown> {
		throw new Error('Unsupported handleResponse in AdmAdRepo ' + this.id);
	}
}
